(function ($) {
    $(document).ready(function () {
        $('.explore-desktop-head .button.maximize').on('click', function(e) {
            e.preventDefault();

            const $target = $('.explore-desktop-head .button.maximize svg use');
            const newHref = ($target.attr('href') === '#icon-frame-corners') ? '#icon-corners' : '#icon-frame-corners';
            const buttonText = newHref === '#icon-frame-corners' ? 'Mărește lista' : 'Micșorează lista';

            $target.attr('href', newHref);

            $('.explore-desktop-head .button.maximize span').text(buttonText);

            $('#finderListings').toggleClass('maximized');
        });

        $('#regiune_custom').on('change', function () {
            var selectedValue = $(this).val();
            var data = {
                action: "changeJudet",
                selectedValue: selectedValue
            }
            $.ajax({
                url: loadmore_params.ajaxurl,
                type: 'POST',
                data: data,
                success: function (response) {
                    if (Array.isArray(response)) {
                        var optionsDiv = $('#my-options-div');
                        if (!optionsDiv.length) {
                            optionsDiv = $('<div id="my-options-div"></div>').css('display', 'none');
                            $('body').append(optionsDiv);
                            $('#localitate_custom option').clone().appendTo(optionsDiv);

                            var options = $('#localitate_custom option').toArray();

                            $('#localitate_custom option').each(function () {
                                var optionText = $(this).text().trim();
                                if (!response.includes(optionText)) {
                                    $(this).remove();
                                }
                            });
                        } else {
                            $('#localitate_custom').empty();
                            $('#my-options-div option').each(function () {
                                var optionText = $(this).text().trim();
                                if (response.includes(optionText)) {
                                    $('#localitate_custom').append($(this));
                                }
                            });
                        }

                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr);
                }
            });
        });

        if ($('.he-feed-carousel').length > 0) {
            $('.he-feed-carousel').owlCarousel({
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1024: {
                        items: 4
                    }
                },
                nav: true,
                items: 4,
                loop: true,
                margin: 20,
                autoplay: true,
                autoplayHoverPause: true,
                navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"]
            });
        }

        $('.he-find-alerts li').on('click', (e) => {
            if ('a' === $(e.target)[0].localName) {
                return true;
            }

            $('.he-find-alerts li').removeClass('active');
            $(e.target).addClass('active');

            $('.he-alert-tabs li').removeClass('active');
            $('.he-alert-tabs li#' + $(e.target).data('tabName')).addClass('active')
        });

        //Reinitialize the header carousel
        let $headerCarousel = $('.header-gallery-carousel');
        let responsiveOptions = {};
        const itemCount = $headerCarousel.children().length;

        $headerCarousel.trigger('destroy.owl.carousel');
        $headerCarousel.addClass('he-alert-tabs');

        if (itemCount === 1) {
            responsiveOptions = {
                0: {
                    items: 1,
                },
            };
        } else if (itemCount === 2) {
            responsiveOptions = {
                0: {
                    items: 1,
                },
                1000: {
                    items: 2,
                },
            };
        } else if (itemCount >= 3) {
            responsiveOptions = {
                0: {
                    items: 1,
                },
                600: {
                    items: 2,
                },
                1000: {
                    items: 3,
                },
            };
        }

        if ($headerCarousel.length > 0) {
            $headerCarousel.owlCarousel({
                nav: true,
                responsive: responsiveOptions,
                navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"]
            });
        }

        $('#social-share-modal .modal-close').on('click', () => {
            $('#social-share-modal').trigger('hide.bs.modal');
        });

        // Fix the Filter search on load
        $(document).ready(function () {
            const $select = $('.types-dropdown-wrapper select');

            $select.on('select2:loaded', explorerFilterFix);
            $select.trigger('select2:loaded');
        });

        if ($('.he-finished-alert-images').length > 0) {
            $('.he-finished-alert-images').owlCarousel({
                items: 4,
                nav: false,
                loop: true,
                margin: 20,
                autoplay: true,
                autoplayHoverPause: true,
            });
        }

        function explorerFilterFix() {
            const $select = $('.types-dropdown-wrapper select');
            const type = getUrlParam('type');

            if ($select.length > 0 && type !== null) {
                const typeId = $select.find(`option[value="${type}"]`).attr('data-select2-id');
                const allId = $select.find('option:first-child').attr('data-select2-id');
                $('.types-dropdown-wrapper select').attr('data-select2-id', allId).val('toate').trigger('change');

                setTimeout(() => {
                    $select.attr('data-select2-id', typeId).val(type).trigger('change');
                }, 100);
            }
        }

        /**
         * Get URL Parameter
         *
         * @param param
         * @param urlParam
         * @returns {string}
         */
        function getUrlParam(param, urlParam = window.location.href) {
            const urlObj = new URL(urlParam);

            // Get the URL parameters
            const urlParams = urlObj.searchParams;

            // Get the value of a specific parameter
            return urlParams.get(param);
        }
    });
})(jQuery)
